export default __webpack_public_path__ + "static/media/APB-Logo.93f64f54.svg";